import React, { useEffect, useMemo } from 'react'
import { RouterProvider } from 'react-router-dom'

import { useTenant } from '@emerald-works-nova/auth'
import { cornerstoneRouter } from './cornerstone-router'
import { enterpriseRouter } from './enterprise-router'
import consts from '../consts'
import { consumerRouter } from './consumer-router'

export const ApplicationRouterProvider = ({ onChangeMainColor }) => {
  const tenant = useTenant()
  const router = useMemo(() => {
    if (!tenant) return null

    if (tenant.tenantKey === 'cornerstone') {
      return cornerstoneRouter
    }

    if (tenant.pk === consts.DEFAULT_CLUB_PK) {
      return consumerRouter
    }

    return enterpriseRouter
  }, [tenant])

  useEffect(() => {
    if (tenant && tenant.mainColor) {
      onChangeMainColor(tenant.mainColor)
    }
  }, [tenant, onChangeMainColor])

  if (!tenant) return null

  return (
    <RouterProvider
      router={router}
    />
  )
}
